import { createTheme } from "@mui/material/styles";
import { FONT_SANS, FONT_DISPLAY } from "./v2Tokens";

const baseTheme = {
  typography: {
    fontFamily: FONT_SANS,
    h1: { fontFamily: FONT_DISPLAY },
    h2: { fontFamily: FONT_DISPLAY },
    h3: { fontFamily: FONT_DISPLAY },
    h4: { fontFamily: FONT_DISPLAY },
  },
  shape: {
    borderRadius: 6,
  },
};

export const v2DarkTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: "dark",
    primary: { main: "#06D6A0" },
    secondary: { main: "#A78BFA" },
    background: {
      default: "#0B1120",
      paper: "#111827",
    },
    text: {
      primary: "#F1F5F9",
      secondary: "#94A3B8",
    },
    error: { main: "#FB7185" },
    warning: { main: "#FBBF24" },
    info: { main: "#38BDF8" },
    success: { main: "#34D399" },
  },
});

export const v2LightTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: "light",
    primary: { main: "#059669" },
    secondary: { main: "#7C3AED" },
    background: {
      default: "#F8FAFC",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#0F172A",
      secondary: "#475569",
    },
    error: { main: "#E11D48" },
    warning: { main: "#D97706" },
    info: { main: "#0284C7" },
    success: { main: "#059669" },
  },
});
